import { parseData } from './data.js';
import { runSimulation } from './simulation.js';
import { removeDots } from './movement.js';

export { parseData, runSimulation, removeDots };



// WEBPACK FOOTER //
// ./src/utils/index.js